{
  "decrease": "Зменшити {fieldLabel}",
  "increase": "Збільшити {fieldLabel}",
  "numberField": "Поле номера"
}
